import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { TENANTS_INFO, COMPANY_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { Store } from '@ngrx/store';
import { ToastMessageService } from '@fitness-force/api';
import { AttachmentService } from '@fitness-force/api';
import { ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { InputTextModule } from 'primeng/inputtext';


import { SelectModule } from 'primeng/select';
import { FileUploadModule } from 'primeng/fileupload';
import { DomSanitizer } from '@angular/platform-browser';
import { FolderCreateDialogComponent } from '../create-folder-dialog/folder-create-dialog.component';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';

@Component({
  selector: 'add-attachment-dialog',
  templateUrl: './add-attachment-dialog.component.html',
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    DynamicDialogModule,
    FormsModule,
    ErrorMsgComponent,
    InputTextModule,
    ButtonModule,
    SelectModule,
    FileUploadModule,
    TranslateModule,
    NgxFileDropModule
]
})
export class AddAttachmentDialogComponent implements OnInit {
  getAccessTenantList$: Observable<any> = new Observable();
  selectedTenant$: Observable<any> = new Observable();
  tenantId = 0;
  clientId!: number

  primaryLanguage!: string;
  secondaryLanguage!: string;
  isSecondaryLanguage = false;

  folderForm!: UntypedFormGroup;

  isSubmitting = false;

  documentTypes: any[];
  selectedDocumentType: { name: string; } | undefined;

  file!: File;
  refDialog?: DynamicDialogRef;
  constructor(public ref: DynamicDialogRef, private store: Store,
    public config: DynamicDialogConfig,
    public translate: TranslateService,
    private attachmentService: AttachmentService,
    private toastMessageService: ToastMessageService,
    private cd: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService,
  ) {
    this.clientId = this.config.data?.clientId;
  }

  ngOnInit(): void {

    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    combineLatest([
      this.getAccessTenantList$,
      this.store.select(COMPANY_INFO),
    ]).subscribe({
      next: ([tenant, company]: any) => {
        this.tenantId = tenant.selected_tenant.id;
        if (this.tenantId > 0) {
          this.store.dispatch({ type: 'ROUTER_GO' });

            if(tenant.selected_tenant?.secondary_language){
            this.isSecondaryLanguage = true;
            this.translate
              .get([
                'common.LANGUAGE.' +
                tenant.selected_tenant.primary_language?.toUpperCase(),
                'common.LANGUAGE.' +
                tenant.selected_tenant.secondary_language?.toUpperCase(),
              ])
              .subscribe((translations) => {
                this.primaryLanguage =
                  translations[
                  'common.LANGUAGE.' +
                  tenant.selected_tenant.primary_language?.toUpperCase()
                  ];
                this.secondaryLanguage =
                  translations[
                  'common.LANGUAGE.' +
                  tenant.selected_tenant.secondary_language?.toUpperCase()
                  ];
              });
          }
          this.getDocumentType();
          this.createFolderForm();
        }
      },
    });
  }


  getDocumentType(activeFolder: any = null) {
    this.attachmentService.getAttachments(this.tenantId).subscribe(
      {
        next: (res: any) => {
          if (res.items && res.items.length > 0) {
            this.documentTypes = res.items.filter((folder: any) => {
              return String(folder.description_primary_language).toLowerCase() != "waiver";
            })
            if (activeFolder) {
              this.DocumentTypeID.setValue(this.documentTypes.find((value: any) => {
                return value.id == activeFolder.id;
              }))
              this.cd.detectChanges()
            }
          } else {
            this.documentTypes = [];
          }
        }, error: (error: any) => {
          this.handleError(error)
        }
      })
  }


  createFolderForm() {
    this.folderForm = this.fb.group({
      document_type_id: ["", Validators.required],
      document_file_base64: ["", Validators.required],
    });
    this.cd.detectChanges();
  }
  get DocumentTypeID(): UntypedFormControl {
    return this.folderForm.get('document_type_id') as UntypedFormControl
  }
  get DocumentFile(): UntypedFormControl {
    return this.folderForm.get('document_file_base64') as UntypedFormControl
  }

  saveFolderForm() {
    if (this.folderForm.valid) {
      const data = this.folderForm.value;
      data.document_type_id = data.document_type_id.id;
      // removing base64
      data.document_file_base64 = data.document_file_base64.split(",")[1]
      this.isSubmitting = true;
      this.attachmentService.uploadDocument(this.tenantId, this.clientId, data).subscribe({
        next: (res: any) => {
          this.isSubmitting = false;
          this.translate
            .get('ADMIN.DOCUMENT.CREATE_SUCCESS_MESSAGE')
            .subscribe((translations) => {
              this.toastMessageService.showSuccess(translations);
            });
          this.ref.close(res);
        },
        error: (error: any) => {
          this.isSubmitting = false;
          this.handleError(error)
        }
      })

    } else {
      // Todo Fire all control touches ...
      Object.keys(this.folderForm.controls).forEach((field) => {
        const control = this.folderForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });

      this.cd.detectChanges();
    }
  }

  close() {
    this.ref.close();

  }

  handleError(error: any) {
    if (error instanceof NotFoundError) {
      this.translate.get('common.errors.SERVER_SIDE.PAGE_NOT_FOUND')
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    } else {
      this.translate
        .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
        .subscribe((translations: any) => {
          this.toastMessageService.showErrorMessage(translations);
        });
    }


  }

  onFileSelect(event: any) {
    if (event?.currentFiles && event?.currentFiles.length > 0) {
      this.file = event.currentFiles[0] as File;
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = (dataFile) => {
        this.DocumentFile.setValue(dataFile.target?.result)
        this.cd.detectChanges();
      };
    }
  }

  handleFileSelect(files: NgxFileDropEntry[]) {
    const file: NgxFileDropEntry = files[0];
    if (file.fileEntry.isFile) {
      const fileEntry = file.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        this.file = file;
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = (dataFile) => {
          this.DocumentFile.setValue(dataFile.target?.result)
          this.cd.detectChanges();
        };
      });
    }
  }

  getSanitizedURL() {
    return this.sanitizer.bypassSecurityTrustUrl(this.DocumentFile.value);
  }

  removeDocument() {
    this.DocumentFile.setValue(null);
  }


  addFolder(activeFolder: any = null) {
    //this.attachmentsModal=false;
    this.refDialog = this.dialogService.open(FolderCreateDialogComponent, {
      showHeader: false,
      baseZIndex: 10000,

      contentStyle: { 'max-height': '500px', 'min-width': '400px', 'max-width': '600px' },
      data: { activeFolder },
    });
    this.refDialog.onClose.subscribe((folder: any) => {
      if (folder) {
        this.getDocumentType(folder);
      }
    });
  }


}
